import { useState } from "react";
import type { Product } from "@/mocks/products";

type ProductCardProps = {
  product: Product;
  showVendor?: boolean;
};

export default function ProductCard({ product, showVendor = true }: ProductCardProps) {
  const [wished, setWished] = useState(false);

  return (
    <article className="group relative" data-product-shop>
      <a href={product.href} className="block">
        <div className="relative w-full aspect-square overflow-hidden bg-background-100">
          <img
            src={product.image}
            alt={product.title}
            title={`${product.title} — Sofia Jewelry`}
            className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          {product.soldOut && (
            <span className="absolute top-3 left-3 bg-background-50/90 text-foreground-700 font-label text-[10px] tracking-[0.18em] uppercase px-3 py-1">
              Sold out
            </span>
          )}
        </div>
      </a>

      <button
        type="button"
        aria-label={wished ? "Remove from wishlist" : "Add to wishlist"}
        onClick={() => setWished((prev) => !prev)}
        className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/85 text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
      >
        <i className={wished ? "ri-heart-fill text-base text-primary-600" : "ri-heart-line text-base"} />
      </button>

      <div className="pt-4 text-center">
        {showVendor && (
          <p className="font-label text-[11px] tracking-[0.2em] uppercase text-foreground-500 mb-1.5">
            {product.vendor}
          </p>
        )}
        <h3 className="font-body text-sm text-foreground-900 leading-snug mb-2 min-h-[2.6rem]">
          <a href={product.href} className="hover:text-primary-600 transition-colors">
            {product.title}
          </a>
        </h3>
        <p className="font-body text-sm text-foreground-600">{product.price}</p>
      </div>
    </article>
  );
}